import * as React from "react";
import { PromptResult } from "./businessReportOutcomeContent";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";
import { Evidence } from "@/types/evidences";
import { outcomeEvidences } from "./outcomeEvidences";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails | null;
  inProgress: boolean;
  setEvidences: React.Dispatch<React.SetStateAction<Evidence[]>>;
  setPromptsResult: (prompts: PromptResult[]) => void;
}

export const BusinessReportOutcomeInit: React.FC<Props> = ({
  businessReportOutcome,
  inProgress: inProgress,
  setPromptsResult,
  setEvidences,
}) => {
  const { setCurrentPdfId } = useCurrentPdf();

  React.useEffect(() => {
    if (businessReportOutcome) {
      const evidences = outcomeEvidences(businessReportOutcome);
      setEvidences(prev => [...prev, ...evidences]);

      setPromptsResult(
        [...businessReportOutcome.result]
          .filter(r => !r.is_note)
          .sort((a, b) => a.order - b.order)
          .map((prompt, index) => ({
            prompt: prompt.prompt ?? "",
            name: prompt.name,
            order: prompt.order,
            date: prompt.date,
            is_date: prompt.is_date,
            data_type: prompt.data_type ?? (prompt.is_date ? "date" : null),
            business_report_prompt_id: prompt.business_report_prompt_id ?? "",
            processing: inProgress ? index == 0 : false,
            show: inProgress ? index == 0 : true,
            business_report_outcome_result_id: prompt.id,
            content: prompt.result,
            relevancy: prompt.data_type === "relevancy" ? (prompt.relevancy ?? null) : null,
            error_message: prompt.error_message,
            edited_by_id: prompt.edited_by_id,
            edited_at: prompt.edited_at,
            traffic_light: prompt.traffic_light,
            rating: prompt.rating,
            snapshot_citations: prompt.snapshot_citations,
            result_details: prompt.result_details,
            web_search_sources: {
              ...prompt.web_search_sources,
              sources: prompt.web_search_sources?.sources ?? [],
              search_entry_point_html: prompt.web_search_sources?.search_entry_point_html ?? null,
            },
          })),
      );

      if (businessReportOutcome.fs_entry) {
        setCurrentPdfId(businessReportOutcome.fs_entry.id);
      }
    }
  }, [setCurrentPdfId, businessReportOutcome, inProgress, setPromptsResult, setEvidences]);

  return null;
};
